import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-fecha-hora-material',
  templateUrl: './fecha-hora-material.component.html',
  styleUrls: ['./fecha-hora-material.component.css']
})
export class FechaHoraMaterialComponent implements OnInit {

  // @Output() dateChangedOut = new EventEmitter();
  strFchRecep = '';
  flgSoloLectura = false;

  constructor() { }

  ngOnInit() {
  }

  setFechaHoraMaterialC(fechaHora: string) {

    this.strFchRecep = fechaHora;

  }

  setSoloLectura(flgValor: boolean) {

    this.flgSoloLectura = flgValor;

  }


  getFechaHoraMaterialC() {

    return this.strFchRecep;

  }

  _dateChanged(event: any) {

    if (event.value) {

      this.strFchRecep = event.value.toString();

      // this.dateChangedOut.emit(this.strFchRecep);

    }


  }

}
